<template>
  <div class="price-information mt-lg-0 bg-2 p-4 rounded-16">
    <snow-input
      v-model="form.price"
      money
      id="price"
      label="Valor em Real Brasileiro (R$)"
      :rules="rules.pricing"
    />
    <snow-input
      v-model="form.price_usd"
      :disabled="isParceledBillet"
      money
      :moneyConfig="{ ...moneyConfig, prefix: 'US$ ' }"
      class="my-5"
      id="price"
      label="Valor em Dólar Americano (US$)"
      :rules="rules.foreignPricing"
    />
    <snow-input
      v-model="form.price_eur"
      :disabled="isParceledBillet"
      money
      :moneyConfig="{ ...moneyConfig, prefix: '€' }"
      class="my-5"
      id="price"
      label="Valor em Euro (€)"
      :rules="rules.foreignPricing"
    />

    <payment-methods
      v-model="form.payment_methods_ids"
      :showForeignInfo="showForeignInfo"
    />

    <template v-if="isParceledBillet">
      <snow-select
        v-model="form.billet_installments"
        class="my-5"
        label="Parcelamento"
        :options="billetInstallmentOptions"
      />

      <bp-switch
        v-model="form.billet_apply_interest"
        label="Taxa sobre parcelamento de boletos"
      />
      <div class="functional-2 text-neutral-400">
        Em uma compra parcelada por boletos, serão aplicados juros sobre as
        parcelas.
      </div>
    </template>

    <template v-else-if="isCardSale">
      <snow-select
        v-model="form.installments"
        class="my-5"
        label="Parcelamento"
        :options="installmentOptions"
        :disabled="disableInstallments"
      />

      <div class="d-flex align-items-center mt-5">
        <snow-switch
          v-model="form.is_tax_to_producer"
          class="mr-5 text-switch"
          id="product-status"
          label="Taxas para o produtor"
          info="Em uma compra parcelada, o produtor pagará as taxas do parcelamento"
        />
      </div>

      <div class="d-flex align-items-center mt-5">
        <snow-switch
          v-model="form.smart_installment"
          class="mr-5"
          id="smart-installment"
          label="Recuperar automaticamente vendas de cartões com limite insuficiente."
          info="Em uma compra parcelada, se o cartão é negado por saldo insuficiente,
        cobramos as parcelas em formato de recorrência para tentar evitar que
        você perca a venda."
        />
      </div>
    </template>

    <snow-select
      v-model="form.warranty"
      class="mt-5 mb-2"
      id="warranty"
      label="Garantia do produto *"
      :options="warranties"
    />

    <span class="text-dark-40 fs-14">
      Esse também é o prazo que o cliente tem para pedir reembolso. No Brasil, o
      prazo mínimo é de 7 dias e na União Europeia, de 15 dias.
    </span>
  </div>
</template>
<script>
import SnowSelect from "@/components/snow-ui/form/SnowSelect.vue";
import SnowSwitch from "@/components/snow-ui/SnowSwitch.vue";
import { moreOrEqualTo } from "@/functions/validation";
import { mapState } from "vuex";
import PaymentMethods from "./PaymentMethods.vue";
export default {
  components: {
    PaymentMethods,
    SnowSelect,
    SnowSwitch
  },
  props: {
    form: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    isSignature: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    actualStep: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingInstallments: false,
      moneyConfig: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "",
        masked: false
      },
      rules: {
        pricing: [moreOrEqualTo(4)],
        foreignPricing: [
          val =>
            !!(!val || val >= 4) ||
            "Caso haja valor, deve ser maior ou igual a 4"
        ]
      }
    };
  },
  computed: {
    ...mapState("product", ["currencies", "warranties"]),
    ...mapState("sale", ["installments"]),
    isParceledBillet() {
      return !!this.form.payment_methods_ids.find(p => p == 6);
    },
    billetInstallmentOptions() {
      return Array(18)
        .fill()
        .map((_, i) => ({
          id: i + 1,
          name: `Até ${i + 1} parcela${i ? "s" : ""}`
        }));
    },
    isCardSale() {
      return !!this.form.payment_methods_ids.find(p => [1, 3, 34].includes(p));
    },
    installmentOptions() {
      const opts = [];
      for (let id in this.installments) {
        opts.push({
          id: parseInt(id),
          name: `Até ${id} parcelas de R$ ${this.installments[id]}`
        });
      }
      return opts;
    },

    allowInstallments() {
      return !!this.form.payment_methods_ids.filter(p =>
        ["parceled_billet", 1, 3, 34].includes(p)
      ).length;
    },
    disableInstallments() {
      return !!(
        this.loadingInstallments ||
        !this.form.price ||
        this.form.price < 4 ||
        !this.allowInstallments
      );
    },
    showForeignInfo() {
      return !!this.form.price_usd || !!this.form.price_eur;
    }
  },
  methods: {
    getInstallments(v) {
      if (v < 4 || this.isParceledBillet) return;

      this.loadingInstallments = true;
      this.$store
        .dispatch("sale/getInstallments", {
          installments: 18,
          value: v
        })
        .finally(() => {
          this.loadingInstallments = false;
        });
    }
  },
  watch: {
    "form.price"(v) {
      this.getInstallments(v);
    },
    isParceledBillet(v) {
      if (v) {
        this.form.price_usd = 0;
        this.form.price_eur = 0;
      }
    }
  }
};
</script>
